
import Vue, { PropType } from 'vue';
import { formatAgentQuantity, getTerritoryAccess } from '@/utils';
import createTerritoryAccessRequest from '@/services/territory-access/create';
import Tag from '@/components/Tag/index.vue';
import { TerritoryInfo } from '../../config/types';
import Modal from '../Modal/index.vue';
import Button from '../Button/index.vue';
import Card from '../Card/index.vue';
import {
  AccessDetails, HeadDetails, Label, Requested, Wrapper,
} from './styles';

export default Vue.extend({
  name: 'ResultSearch',
  components: {
    AccessDetails,
    Button,
    Card,
    HeadDetails,
    Label,
    Requested,
    Wrapper,
    Modal,
    Tag,
  },
  props: {
    territoryInfo: Object as PropType<TerritoryInfo>,
    isAdminUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalActivated: false,
      buttonDisable: false,
      headerColumns: {
        title: ['voltar', 'voltar2', 'voltar3'],
      },
      modalButtons: [
        {
          click: 'closeModal',
          title: 'Ok, voltar',
          type: 'primary',
        },
      ],
    };
  },
  methods: {
    formatAgent(agents: []) {
      return formatAgentQuantity(agents);
    },
    formatTerritoryAccessMessage(territoryAccess: number) {
      return getTerritoryAccess(territoryAccess);
    },
    async makeRequest(territoryId: string) {
      this.buttonDisable = true;
      const userLogged = sessionStorage.getItem('userLogged') as string;
      const parse = JSON.parse(userLogged);
      const { idUser, company } = parse;

      const responseCreate = {
        frigId: idUser.toString(),
        territoryId,
        tokenKey: company.stKey.toString(),
      };
      const territory = await createTerritoryAccessRequest(responseCreate);
      if (!territory.hasError) {
        this.isModalActivated = true;
      }
      // this.isModalActivated = true;
    },
    closeModal() {
      this.isModalActivated = false;
      this.buttonDisable = false;
    },
  },
});
